var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 19,
    viewBox: "0 0 92 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6393 15.6249L9.39806 7.14176L7.12115 15.6249H3.94906L0.00390625 3.35608H3.28026L5.64266 12.3825L7.95339 3.35608H10.9536L13.316 12.3825L15.6436 3.35608H18.7819L14.7992 15.6249H11.6393Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9336 5.80985V8.24643H28.6926V10.7002H22.9336V13.1759H29.5032V15.6297H19.8639V3.35608H29.3135V5.80985H22.9336Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.677 13.0136V15.6249H31.4861V3.35608H34.5558V13.0136H39.677Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3332 13.0136V15.6249H41.1423V3.35608H44.212V13.0136H49.3332Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3252 0H53.0961C52.1711 0 51.4213 0.762173 51.4213 1.70236V17.2976C51.4213 18.2378 52.1711 19 53.0961 19H90.3252C91.2501 19 92 18.2378 92 17.2976V1.70236C92 0.762173 91.2501 0 90.3252 0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3818 3.35608C64.0899 3.35608 65.8136 4.54764 65.8136 6.42281C65.8136 7.72035 65.0208 8.75437 63.7471 9.12196C65.2641 9.4208 66.2297 10.6295 66.2297 12.225C66.2297 14.3102 64.4365 15.6249 61.5913 15.6249H55.6736V3.35608H61.3818ZM58.7264 8.26362H61.2099C62.1061 8.26362 62.6753 7.77286 62.6753 6.98422C62.6753 6.19558 62.1061 5.74301 61.2099 5.74301H58.7264V8.26362ZM58.7264 13.2237H61.2099C62.3484 13.2237 63.0548 12.7157 63.0548 11.8392C63.0548 11.0153 62.3484 10.5073 61.2099 10.5073H58.7264V13.2237Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0729 5.80985V8.24643H76.8328V10.7002H71.0729V13.1759H77.6425V15.6297H68.0032V3.35608H77.4527V5.80985H71.0729Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2125 5.86228V15.6248H82.1437V5.86228H78.5396V3.34167H88.8514V5.86228H85.2125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default ForwardRef;